import * as yup from 'yup';
//import { AppUserFile } from './AppUserFile';
export class UserELP {
    userELPId: number;
    userELPStringId: string;
    userProfileId: string;
    dateAdded: Date;
    situationId?: number;
    description?: string;
    agree: boolean;
    elpId: number;
    elp: string;
    hasAE2: boolean;
    dateAdded2?: Date;
    situationId2?: number;
    description2?: string;
    agree2?: boolean;
    elpId2?: number;
    elp2: string;
    hasAE3: boolean;
    dateAdded3?: Date;
    situationId3?: number;
    description3?: string;
    agree3?: boolean;
    elpId3?: number;
    elp3: string;
    adminNote1?: string;
    adminNote2?: string;
    adminNote3?: string;
    userLetter1?: string;
    userLetter2?: string;
    userLetter3?: string;
}

const situations = [{
    value: 1,
    text: 'A. Previous/Current CPSA practice permit has been obtained'
}, {
        value: 2,
        text: 'B. My undergraduate or postgraduate medical education experience is in a country where English is the first and native language (see above for approved list as per CPSA))'
    }, {
        value: 3,
        text: 'C. More than 50% of my undergraduate and postgraduate medical education (including residency and clinical fellowship training) was taken in a country where English is the first and native language (see above for approved list as per CPSA)'
    }, {
        value: 4,
        text: 'D. I am in independent practice in Canada or in a country where English is the first and native language (see above for list as approved by CPSA) and have already met ELP requirements before registering with your regulatory body'
    }, {
        value: 5,
        text: 'E. I have obtained a previous exemption letter from the AIMG Program'
    }];

export const DateFields = [
    "dateAdded"
];

export const ValidationSchema = yup.object().shape({
    //situationId: yup.string().required('Required'),
    //description: yup.string().required('Required').max(1000),
    //agree: yup.boolean().required('Required'),

    //situationId2: yup.mixed().when('hasAE2', {
    //    is: (has) => has,
    //    then: (schema) => schema.required('Required'),
    //    otherwise: undefined
    //}),

    //description2: yup.mixed().when('hasAE2', {
    //    is: (has: boolean) => has,
    //    then: (schema) => schema.required('Required'),
    //    otherwise: undefined
    //}),
    //agree2: yup.mixed().when('hasAE2', {
    //    is: (has) => has,
    //    then: (schema) => schema.required('Required'),
    //    otherwise: undefined
    //}),

    //situationId3: yup.mixed().when('hasAE3', {
    //    is: (has) => has,
    //    then: (schema) => schema.required('Required'),
    //    otherwise: undefined
    //}),
    //description3: yup.mixed().when('hasAE3', {
    //    is: (has) => has,
    //    then: (schema) => schema.required('Required'),
    //    otherwise: undefined
    //}),
    //agree3: yup.mixed().when('hasAE3', {
    //    is: (has) => has,
    //    then: (schema) => schema.required('Required'),
    //    otherwise: undefined
    //}),
});